// Founder Story content — edit this file to update the "About Me" section on the landing page.
// photo: set to your headshot URL (upload it in chat and I'll swap it, or paste a public image URL here).
export const founder = {
  name: "B. Lewis",
  title: "Founder, Lewis Expert Enterprise",
  location: "Texas, USA",
  photo: "/founder.jpg",
  // Welcome video: paste a YouTube link (e.g. "https://youtu.be/XXXX" or "https://www.youtube.com/watch?v=XXXX").
  // Leave empty ("") to hide the "Watch my welcome" button.
  videoUrl: "",
  videoLabel: "Watch my 60-second welcome",
  headline: "I built the guide I wish I'd had when I formed my first Texas LLC.",
  paragraphs: [
    "When I formed my first LLC, I nearly paid a filing service hundreds of dollars for paperwork the State of Texas lets you file yourself in an afternoon. The information was out there — it was just scattered across a dozen government sites, forums, and upsell-heavy blogs.",
    "So I wrote everything down: every form, every fee, every deadline, in the order you actually need it. That checklist became this guide. It's Texas-only on purpose, and it's built so a first-time founder can go from idea to a filed, compliant LLC without a lawyer.",
    "I run this independently, and I personally read every email. If something in the guide is unclear, tell me — I'll fix it for you and for the next founder.",
  ],
  stats: [
    { value: "100+", label: "Texas founders guided" },
    { value: "35", label: "Checkpoints, start to finish" },
    { value: "<24h", label: "Personal email reply time" },
  ],
  email: "info@texasllcguide.llc",
  linkedin: "", // optional: "https://www.linkedin.com/in/your-handle"
};
